var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-group",
    {
      attrs: {
        dense: "",
        "prepend-icon": "poll",
        "active-class": "activeLinkGroup",
        "no-action": "",
      },
    },
    [
      _c(
        "v-list-tile",
        { attrs: { slot: "activator" }, slot: "activator" },
        [_c("v-list-tile-title", [_vm._v(_vm._s(_vm.$t("App.Reports")))])],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-list",
        { staticClass: "py-0", attrs: { dense: "" } },
        [
          _vm.reportTypeIsVisible(_vm.reportObjects.wqMonthly.configKey) ||
          _vm.reportTypeIsVisible(_vm.reportObjects.bcMoeMonthly.configKey)
            ? _c(
                "v-list-tile",
                {
                  attrs: {
                    ripple: "",
                    to: { name: "monthlyWaterQualityReport" },
                    "active-class": "activeLink",
                  },
                },
                [
                  _c("v-list-tile-title", [_vm._v("Monthly Water Quality")]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("analytics")])],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.reportTypeIsVisible(_vm.reportObjects.riss.configKey)
            ? _c(
                "v-list-tile",
                {
                  attrs: {
                    ripple: "",
                    to: { name: "monthlyRISSReport" },
                    "active-class": "activeLink",
                  },
                },
                [
                  _c("v-list-tile-title", [_vm._v("Monthly RISS")]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("analytics")])],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.reportTypeIsVisible(_vm.reportObjects.allExport.configKey)
            ? _c(
                "v-list-tile",
                {
                  attrs: {
                    ripple: "",
                    to: { name: "exportAllDataReport" },
                    "active-class": "activeLink",
                  },
                },
                [
                  _c("v-list-tile-title", [_vm._v("Export All Data")]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("analytics")])],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list-tile",
            {
              attrs: {
                to: { name: "discreteDataQueryReport" },
                ripple: "",
                "active-class": "activeLink",
              },
            },
            [
              _c("v-list-tile-title", [
                _vm._v(_vm._s(_vm.$t("App.DiscreteDataQuery"))),
              ]),
              _vm._v(" "),
              _c(
                "v-list-tile-avatar",
                [_c("v-icon", [_vm._v("analytics")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            {
              attrs: {
                to: { name: "continuousDataQueryReport" },
                ripple: "",
                "active-class": "activeLink",
              },
            },
            [
              _c("v-list-tile-title", [
                _vm._v(_vm._s(_vm.$t("App.ContinuousDataQuery"))),
              ]),
              _vm._v(" "),
              _c(
                "v-list-tile-avatar",
                [_c("v-icon", [_vm._v("mdi-chart-areaspline")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            {
              attrs: {
                to: { name: "rpdReport" },
                ripple: "",
                "active-class": "activeLink",
              },
            },
            [
              _c("v-list-tile-title", [
                _vm._v(_vm._s(_vm.$t("App.RpdReport"))),
              ]),
              _vm._v(" "),
              _c(
                "v-list-tile-avatar",
                [_c("v-icon", [_vm._v("compare_arrows")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.reportTypeIsVisible(_vm.reportObjects.bcMOE.configKey)
            ? _c(
                "v-list-tile",
                {
                  attrs: {
                    ripple: "",
                    to: { name: "BCMOEReport" },
                    "active-class": "activeLink",
                  },
                },
                [
                  _c("v-list-tile-title", [
                    _vm._v(
                      _vm._s(
                        _vm.currentUserGroup.id == 202
                          ? "NWB Monthly Report"
                          : "BC MOE Report"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("mdi-chart-areaspline-variant")])],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.reportTypeIsVisible(
            _vm.reportObjects.tenantGraphDashboard.configKey
          )
            ? _c(
                "v-list-tile",
                {
                  attrs: {
                    ripple: "",
                    to: { name: "tenantGraphDashboard" },
                    "active-class": "activeLink",
                  },
                },
                [
                  _c("v-list-tile-title", [_vm._v("Graphing Dashboard")]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("mdi-view-dashboard")])],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }